import { LOCAL_GALLERY_PHOTOS } from './galleryData.js';

export const MOCK_SITE_SETTINGS = {
  mandirName: "Sri Gnana Sai Baba Mandir",
  mandirNameTa: "ஸ்ரீ ஞான சாய் பாபா மந்திர்",
  eventName: "27 Nakshatra Maha Homam",
  eventNameTa: "ஸ்ரீ 27 நட்சத்திர மகா ஹோமம்",
  eventDatesText: "Sep 24, 2026 – Oct 20, 2026 (27 Consecutive Auspicious Days)",
  phoneNumber: "+91 98412 45070",
  phoneNumbers: ["+91 98412 45070", "+91 63817 20140", "+91 99414 25158"],
  whatsappNumber: (typeof window !== "undefined" && window.__MANDIR_WHATSAPP_NUMBER__) || (typeof window !== "undefined" && localStorage.getItem("mandir_whatsapp_number") && !localStorage.getItem("mandir_whatsapp_number").includes("9080845897") ? localStorage.getItem("mandir_whatsapp_number") : "916369482332"), // Connected Mandir WhatsApp Automation Number
  whatsappDisplayNumber: (typeof window !== "undefined" && window.__MANDIR_WHATSAPP_FORMATTED__) || (typeof window !== "undefined" && localStorage.getItem("mandir_whatsapp_formatted") && !localStorage.getItem("mandir_whatsapp_formatted").includes("90808") ? localStorage.getItem("mandir_whatsapp_formatted") : "+91 63694 82332"),
  email: "gurujiambattur@gmail.com",
  emails: ["gurujiambattur@gmail.com", "vishya9790@gmail.com"],
  venueName: "Sri Gnana Sai Baba Mandir Sanctum Arena",
  venueAddress: "Ragavendra St, Venkateswara Nagar Extension, Ambattur",
  venueCity: "Chennai, Tamil Nadu 600062",
  mapUrl: "https://www.google.com/maps/dir//Sri+Gnana+Sai+Baba+Temple,+Ragavendra+St,+Venkateswara+Nagar+Extension,+Ambattur,+Chennai,+Tamil+Nadu+600062",
  gurujiName: "Guruji",
  gurujiTitle: "Yagna Acharya & Spiritual Guide",
  gurujiBioShort: "Under the divine guidance of Guruji at Sri Gnana Sai Baba Mandir, thousands of devotees find peace of mind, relief from life troubles, and divine blessings through sacred Vedic Yagnas.",
  gurujiPhoto: "/images/guruji.jpg"
};

/* =========================================================
   📅 27-DAY AUTOMATIC DATE SCHEDULE & REGISTRATION STATUS
   Starts: September 24, 2026 (Day 1) to October 20, 2026 (Day 27)
   ========================================================= */
export const HOMAM_START_YEAR = 2026;
export const HOMAM_START_MONTH = 8; // September (0-indexed)
export const HOMAM_START_DAY = 24;

export const getHomamDate = (orderIndex) => {
  const d = new Date(HOMAM_START_YEAR, HOMAM_START_MONTH, HOMAM_START_DAY);
  d.setDate(d.getDate() + (Number(orderIndex) - 1));
  return d;
};

export const formatHomamDate = (orderIndex, options = {}) => {
  const d = getHomamDate(orderIndex);
  if (options.short) {
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  }
  return d.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export const getRegistrationStatus = (orderIndex) => {
  return {
    status: "open",
    label: "Registration Open",
    color: "#10b981",
    canRegister: true,
    cutoffText: "",
    cutoffDate: null,
    closingNotice: "",
  };
};

export const getNakshatraImage = (nak) => {
  if (!nak) return '/images/nakshatras/nakshatra_1.jpg';
  if (nak.image) return nak.image;
  const num = Number(nak.orderIndex) || Number(nak.id) || 1;
  return `/images/nakshatras/nakshatra_${num}.jpg`;
};

/* =========================================================
   🕉️ 3 SACRED SEVA PLANS (CONFIGURED AS REQUESTED)
   1. Individual: ₹1,001 (1 Member)
   2. Family: ₹5,001 (Allowed: Up to 4 Members)
   3. Family with Annadanam: ₹10,001 (Allowed: Up to 4 Members + Silver Sai Baba Coin)
   ========================================================= */
export const HOMAM_SEVA_PLANS = [
  {
    id: "individual",
    name: "Individual Homam",
    nameTa: "தனிநபர் ஹோமம்",
    price: 1001,
    membersAllowed: 1,
    membersText: "Allowed: 1 Devotee",
    badge: null,
    features: [
      "Devotee birth star homam prayer recited in sacred fire",
      "Archana & flower ahuti for your birth star",
      "Divine Raksha (sacred thread) & Vibhuti Prasadam",
    ],
  },
  {
    id: "family",
    name: "Family Maha Homam",
    nameTa: "குடும்ப மகா ஹோமம்",
    price: 5001,
    membersAllowed: 6,
    membersText: "Allowed: Up to 6 Family Members",
    badge: "Most Popular",
    features: [
      "All family members (up to 6) names & Gothram recited",
      "Special herbal Samithu & Desi Cow Ghee Ahuti offering",
      "Sarva Dosha Nivarana & planetary peace homam",
      "Consecrated Raksha threads & full Prasadam pack sent",
    ],
  },
  {
    id: "family_annadanam",
    name: "Family Homam, Go Pooja with Annadanam",
    nameTa: "குடும்ப ஹோமம், கோ பூஜை & அன்னதானம்",
    price: 10001,
    membersAllowed: 6,
    membersText: "Allowed: Up to 6 Family Members + Annadanam",
    badge: "Maha Seva",
    features: [
      "Full family homam (Allowed: Up to 6 Family Members)",
      "Annadanam food sponsorship for devotees",
      "Special Kalasa Theertham blessing",
      "Consecrated Silver Sai Baba Coin",
    ],
  },
];

/* =========================================================
   🕉️ 11 DIVINE BLESSINGS OF HOMAM / ஹோமத்தின் பலன்கள்
   ========================================================= */
export const HOMAM_BENEFITS = [
  {
    id: 1,
    num: "01",
    titleTa: "அமைதி",
    titleEn: "Inner Peace & Tranquility",
    category: "mind_health",
    categoryTa: "மன அமைதி",
    iconName: "Heart",
    description: "Deep mental calm, freedom from anxiety and stress, and harmony within your heart and mind.",
    descriptionTa: "மன அழுத்தம், படபடப்பு நீங்கி ஆத்ம சாந்தியும் குடும்பத்தில் பேரமைதியும் கிட்டும்."
  },
  {
    id: 2,
    num: "02",
    titleTa: "வியாதி நிவாரணம்",
    titleEn: "Disease Relief & Healing",
    category: "mind_health",
    categoryTa: "ஆரோக்கியம்",
    iconName: "Activity",
    description: "Protection against chronic illnesses, physical rejuvenation, and healing by divine cosmic vibrations.",
    descriptionTa: "நீண்ட நாள் நோய்கள் குணமாகி, உடல் பிணிகள் நீங்கி நல்வாழ்வு உண்டாகும்."
  },
  {
    id: 3,
    num: "03",
    titleTa: "தெளிவு",
    titleEn: "Mental Clarity & Wisdom",
    category: "mind_health",
    categoryTa: "மன அமைதி",
    iconName: "Compass",
    description: "Sharp intellect, decision-making confidence, and removal of confusion or self-doubt.",
    descriptionTa: "குழப்பங்கள் மறைந்து சரியான முடிவுகள் எடுக்கும் ஞானமும் புத்தி கூர்மையும் பிறக்கும்."
  },
  {
    id: 4,
    num: "04",
    titleTa: "பித்ரு தோஷ விலக",
    titleEn: "Removal of Pitru Dosham",
    category: "spiritual",
    categoryTa: "ஆன்மீக அருள்",
    iconName: "Flame",
    description: "Cleansing of ancestral curses and generational karmic burdens, opening doors to family prosperity.",
    descriptionTa: "முன்னோர்களின் சாபங்கள் மற்றும் பித்ரு தோஷங்கள் அகன்று வம்ச விருத்தி ஏற்படும்."
  },
  {
    id: 5,
    num: "05",
    titleTa: "ஆயில் பலம் பெற",
    titleEn: "Vital Strength & Longevity",
    category: "mind_health",
    categoryTa: "ஆரோக்கியம்",
    iconName: "Shield",
    description: "Enhancement of Ayul Balam (lifespan), vital life force, and robust immunity against accidents or harm.",
    descriptionTa: "ஆயுள் விருத்தி, அபமிருத்யு தோஷ நிவர்த்தி மற்றும் அசாத்திய உடல் வலிமை கூடும்."
  },
  {
    id: 6,
    num: "06",
    titleTa: "உயர் கல்வி பெற",
    titleEn: "Academic Excellence & Higher Education",
    category: "success",
    categoryTa: "வெற்றி & கல்வி",
    iconName: "GraduationCap",
    description: "Memory power, Saraswati Kataksham, entrance exam success, and triumph in higher educational pursuits.",
    descriptionTa: "கல்வியில் மேன்மை, ஞாபக சக்தி மற்றும் உயர் கல்விக்கான சேர்க்கை தடைகள் விலகும்."
  },
  {
    id: 7,
    num: "07",
    titleTa: "கணவன் மனைவி ஒற்றுமை",
    titleEn: "Unity of Husband & Wife",
    category: "family",
    categoryTa: "குடும்ப ஒற்றுமை",
    iconName: "HeartHandshake",
    description: "Deep affection, understanding, and mutual respect between couples, resolving misunderstandings.",
    descriptionTa: "தம்பதியரிடையே கருத்து வேறுபாடுகள் நீங்கி அன்னியோன்யமும் இல்லற மகிழ்ச்சியும் பெருகும்."
  },
  {
    id: 8,
    num: "08",
    titleTa: "குடும்பத்தில் மகிழ்ச்சி",
    titleEn: "Family Happiness & Harmony",
    category: "family",
    categoryTa: "குடும்ப ஒற்றுமை",
    iconName: "Home",
    description: "A joyful household filled with positive energies, auspicious events, and peaceful coexistence.",
    descriptionTa: "வீட்டில் சுப காரியங்கள் தடையின்றி நடந்து ஆனந்தமும் செல்வ செழிப்பும் நிறையும்."
  },
  {
    id: 9,
    num: "09",
    titleTa: "பயம் நீங்க",
    titleEn: "Freedom from Fear & Anxiety",
    category: "mind_health",
    categoryTa: "மன அமைதி",
    iconName: "ShieldAlert",
    description: "Eradication of unknown fears, evil eye (Drishti), depression, and emotional insecurities.",
    descriptionTa: "கெட்ட கனவுகள், கண் திருஷ்டி, காரிய பயம் மற்றும் மன சஞ்சலங்கள் அடியோடு விலகும்."
  },
  {
    id: 10,
    num: "10",
    titleTa: "தடைகள் விலகி வெற்றி",
    titleEn: "Overcoming Obstacles & Victory",
    category: "success",
    categoryTa: "வெற்றி & கல்வி",
    iconName: "Trophy",
    description: "Dissolving legal, business, and personal hurdles, granting success in all noble undertakings.",
    descriptionTa: "தொழில், வேலை, சுப காரியங்களில் ஏற்படும் சகல தடைகளும் நீங்கி வெற்றி நிச்சயம்."
  },
  {
    id: 11,
    num: "11",
    titleTa: "குருவின் அருள் கிடைக்க",
    titleEn: "Blessings & Grace of the Guru",
    category: "spiritual",
    categoryTa: "ஆன்மீக அருள்",
    iconName: "Sparkles",
    description: "Attaining the continuous protective shield, guidance, and spiritual elevation of Sri Sadguru.",
    descriptionTa: "சத்குருவின் பூரண கடாட்சமும் ஆசியும் பெற்று வாழ்வாங்கு வாழும் பேறு கிட்டும்."
  }
];


const RAW_NAKSHATRAS = [
  {
    id: 1,
    slug: "shatabhisha",
    nameEn: "Shatabhisha",
    nameTa: "சதயம்",
    image: "/images/nakshatras/shatabhisha.png",
    orderIndex: 1,
    assignedDate: "Sep 24, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Varuna (God of Cosmic Oceans)",
    deityTa: "வருண பகவான் (மழை / சமுத்திர தேவன்)",
    rulingPlanet: "Rahu",
    rulingPlanetTa: "ராகு",
    symbol: "Empty Circle / 100 Physicians",
    symbolTa: "வெற்று வட்டம் / நூறு மருத்துவர்கள்",
    rasi: "Kumbha (Aquarius)",
    rasiTa: "கும்பம்",
    sacredTree: "Kadambu (Neolamarckia cadamba)",
    sacredElement: "Ether (Akasha)",
    shortDescription: "The Hundred Healers Star of Cosmic Secrets, Immortality & Lord Varuna.",
    introContent: "Shatabhisha ('Hundred Physicians') holds the master key to curing deep illnesses and mystery afflictions. Governed by Varuna, it offers divine nectar on this sacred opening day.",
    benefits: [
      "Cure for complicated, undiagnosed physical ailments",
      "Liberation from intense Rahu shadow periods and anxiety",
      "Occult protection against hostile psychic forces",
      "Oceanic spiritual calm and meditative expansion"
    ],
    moolaMantra: "Om Varunaya Namaha || Om Rahave Namaha",
    searchKeywords: ["shatabhisha", "sathayam", "sadhayam", "chathayam", "sadayam", "satayam", "shatataraka", "shathabhisha", "சதயம்", "சதய", "சதபிஷக்", "kumbha", "aquarius", "கும்பம்", "rahu", "ராகு", "varuna", "வருண பகவான்"]
  },
  {
    id: 2,
    slug: "purva-bhadrapada",
    nameEn: "Purva Bhadrapada",
    nameTa: "பூரட்டாதி",
    image: "/images/nakshatras/purva_bhadrapada.png",
    orderIndex: 2,
    assignedDate: "Sep 25, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Aja Ekapada (The Cosmic Fire Serpent / Rudra)",
    deityTa: "அஜைகபாதர் (ருத்ர பெருமான்)",
    rulingPlanet: "Jupiter (Guru)",
    rulingPlanetTa: "குரு (வியாழன்)",
    symbol: "Front Legs of Funeral Cot / Two-Faced Man",
    symbolTa: "கட்டிலின் முன் கால்கள் / இருமுக மனிதன்",
    rasi: "Kumbha / Meena",
    rasiTa: "கும்பம் / மீனம்",
    sacredTree: "Thembu (Careya arborea)",
    sacredElement: "Ether (Akasha)",
    shortDescription: "The Star of Ascetic Fire, Transformational Power & Aja Ekapada.",
    introContent: "Purva Bhadrapada carries the intense fire of spiritual purification. This homam dissolves egoic attachments and awakens great spiritual strength.",
    benefits: [
      "Spiritual tapasya fulfillment and purification of ego",
      "Overcoming sudden financial downfalls and losses",
      "Jupiter protection during challenging Dasha cycles",
      "Transmutation of difficult life circumstances into wisdom"
    ],
    moolaMantra: "Om Ajaikapade Namaha || Om Gurave Namaha",
    searchKeywords: ["purva bhadrapada", "poorattathi", "purattathi", "poorattadhi", "puratadhi", "purvabhadra", "pooratathi", "பூரட்டாதி", "பூரட்டா", "பூர்வபாத்ரபதா", "kumbha", "meena", "pisces", "மீனம்", "guru", "jupiter", "குரு", "aja ekapada", "அஜைகபாதர்"]
  },
  {
    id: 3,
    slug: "uttara-bhadrapada",
    nameEn: "Uttara Bhadrapada",
    nameTa: "உத்திரட்டாதி",
    image: "/images/nakshatras/uttara_bhadrapada.png",
    orderIndex: 3,
    assignedDate: "Sep 26, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Ahirbudhnya (Auspicious Serpent of the Depths)",
    deityTa: "அஹிர்புத்னியர் (ஆழ்கடல் நாக தேவன்)",
    rulingPlanet: "Saturn (Shani)",
    rulingPlanetTa: "சனி",
    symbol: "Back Legs of Funeral Cot / Snake in Water",
    symbolTa: "கட்டிலின் பின் கால்கள் / நீரில் நாகம்",
    rasi: "Meena (Pisces)",
    rasiTa: "மீனம்",
    sacredTree: "Veppamaram (Neem / Azadirachta indica)",
    sacredElement: "Ether (Akasha)",
    shortDescription: "The Star of Deep Stillness, Kundalini Stability & Ahirbudhnya (Serpent of Depths).",
    introContent: "Uttara Bhadrapada represents the sacred depths of meditation and Kundalini awakening. Governed by Shani and Ahirbudhnya, it grants unshakeable peace.",
    benefits: [
      "Profound meditative stillness and mental equanimity",
      "Overcoming deep-seated fears, grief, and Shani delays",
      "Spiritual liberation and divine guidance in dreams",
      "Protection from hidden natural calamities and hazards"
    ],
    moolaMantra: "Om Ahirbudhnyaya Namaha || Om Sham Shanaishcharaya Namaha",
    searchKeywords: ["uttara bhadrapada", "uthirattathi", "uthirattadhi", "uttirattathi", "uthiratadhi", "uttarabhadra", "uthiratathi", "உத்திரட்டாதி", "உத்திரட்டா", "உத்தரபாத்ரபதா", "meena", "pisces", "மீனம்", "shani", "saturn", "சனி", "ahirbudhnya", "அஹிர்புத்னியர்"]
  },
  {
    id: 4,
    slug: "revati",
    nameEn: "Revati",
    nameTa: "ரேவதி",
    image: "/images/nakshatras/revati.png",
    orderIndex: 4,
    assignedDate: "Sep 27, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Pushan (Celestial Nourisher & Guide)",
    deityTa: "பூஷா (வழிநடத்தும் சூரிய தேவன்)",
    rulingPlanet: "Mercury (Budha)",
    rulingPlanetTa: "புதன்",
    symbol: "Fish / Pair of Fish / Drum",
    symbolTa: "இரட்டை மீன்கள் / உடுக்கை",
    rasi: "Meena (Pisces)",
    rasiTa: "மீனம்",
    sacredTree: "Iluppai (Madhuca longifolia)",
    sacredElement: "Ether (Akasha)",
    shortDescription: "The Star of Divine Journey's Safe Completion, Moksha & Lord Pushan's Nurturing.",
    introContent: "Revati is the auspicious 4th star of our Maha Yagna, marking the nurturing guide of Lord Pushan and the gateway to spiritual fulfillment.",
    benefits: [
      "Protection during travel and safe completion of ventures",
      "Blessings of Moksha, peace, and spiritual fulfillment",
      "Budha Preethi for business prosperity and gentle wealth",
      "Removal of fear and guidance in higher wisdom"
    ],
    moolaMantra: "Om Pooshne Namaha || Om Budhaya Namaha",
    searchKeywords: ["revati", "revathi", "revathy", "ரேவதி", "ரேவதி நட்சத்திரம்", "meena", "pisces", "மீனம்", "budha", "mercury", "புதன்", "pushan", "பூஷா"]
  },
  {
    id: 5,
    slug: "ashwini",
    nameEn: "Ashwini",
    nameTa: "அஸ்வினி",
    image: "/images/nakshatras/ashwini.png",
    orderIndex: 5,
    assignedDate: "Sep 28, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Ashwini Kumaras (Physicians)",
    deityTa: "அஸ்வினி குமாரர்கள்",
    rulingPlanet: "Ketu",
    rulingPlanetTa: "கேது",
    symbol: "Horse's Head (Energy & Vitality)",
    symbolTa: "குதிரைத் தலை",
    rasi: "Mesha (Aries)",
    rasiTa: "மேஷம்",
    sacredTree: "Etti (Strychnos nux-vomica)",
    sacredElement: "Earth (Prithvi)",
    shortDescription: "The Star of Swift Healing, Vitality & Auspicious Beginnings ruled by the divine Ashwini Kumaras.",
    introContent: "Ashwini represents the dawn of cosmic awareness and rapid healing energy. Devotees born in Ashwini or seeking speedy health recovery receive miraculous blessings on this sacred 5th day.",
    benefits: [
      "Relief from chronic illnesses and physical lethargy",
      "Removal of planetary afflictions of Ketu and Mars",
      "Dynamic energy in new business ventures",
      "Speedy obstacle clearance and swift good fortunes"
    ],
    moolaMantra: "Om Ashwinaaya Namaha || Om Shreem Ketave Namaha",
    searchKeywords: ["ashwini", "aswini", "asvini", "ashvini", "aswin", "ashwin", "asuvini", "asuvathi", "aswathi", "ashwathi", "அஸ்வினி", "அசுவினி", "அசுவதி", "அஸ்வதி", "mesha", "aries", "மேஷம்", "ketu", "கேது", "ashwini kumaras"]
  },
  {
    id: 6,
    slug: "bharani",
    nameEn: "Bharani",
    nameTa: "பரணி",
    image: "/images/nakshatras/bharani.png",
    orderIndex: 6,
    assignedDate: "Sep 29, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Yama (God of Dharma)",
    deityTa: "எம தர்மராஜன்",
    rulingPlanet: "Venus (Shukra)",
    rulingPlanetTa: "சுக்கிரன்",
    symbol: "Yoni (Cosmic Womb of Creation)",
    symbolTa: "அடுப்பு / யோனி",
    rasi: "Mesha (Aries)",
    rasiTa: "மேஷம்",
    sacredTree: "Nelli (Amla / Phyllanthus emblica)",
    sacredElement: "Earth (Prithvi)",
    shortDescription: "The Star of Spiritual Transformation, Karmic Cleansing & Divine Justice governed by Lord Yama.",
    introContent: "Bharani bears the transformative power of spiritual discipline and deep cleansing of past karma. The sacred fire purifies generational burdens and establishes righteous living.",
    benefits: [
      "Cleansing of deep karmic debt and past-life obstacles",
      "Liberation from Pithru Doshas and negative energies",
      "Longevity and fearlessness in times of adversity",
      "Elevation of spiritual courage and truthfulness"
    ],
    moolaMantra: "Om Yamaya Dharmarajaya Namaha || Om Shukraya Namaha",
    searchKeywords: ["bharani", "barani", "bharanee", "baranee", "parani", "பரணி", "mesha", "aries", "மேஷம்", "venus", "shukra", "சுக்கிரன்", "yama", "dharmaraja", "எமன்"]
  },
  {
    id: 7,
    slug: "krittika",
    nameEn: "Krittika",
    nameTa: "கிருத்திகை",
    image: "/images/nakshatras/krittika.png",
    orderIndex: 7,
    assignedDate: "Sep 30, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Agni (Fire God)",
    deityTa: "அக்னி தேவன் & முருகப் பெருமான்",
    rulingPlanet: "Sun (Surya)",
    rulingPlanetTa: "சூரியன்",
    symbol: "Razor / Flame",
    symbolTa: "கத்தி / சுடர்",
    rasi: "Mesha / Vrishabha",
    rasiTa: "மேஷம் / ரிஷபம்",
    sacredTree: "Athi (Ficus glomerata)",
    sacredElement: "Fire (Agni)",
    shortDescription: "The Sacred Flame of Purification, Willpower & Muruga's Grace ruled by Lord Agni.",
    introContent: "Governed by Agni Deva and infused with Lord Muruga's valor, Krittika cuts through delusion, burns away inner doubts, and fills devotees with radiant leadership.",
    benefits: [
      "Removal of evil eye, negative entities and deep obstacles",
      "Radiant leadership and authoritative clarity",
      "Blessings of Lord Muruga and Surya for vitality",
      "Conquering long-standing disputes and challenges"
    ],
    moolaMantra: "Om Agnaye Namaha || Om Saravanabhavaya Namaha",
    searchKeywords: ["krittika", "krithika", "karthika", "karthigai", "krithigai", "kiruthigai", "kruthika", "kiruthika", "karthikai", "kiruthiga", "krithiga", "கிருத்திகை", "கார்த்திகை", "கிருத்திகா", "mesha", "vrishabha", "taurus", "ரிஷபம்", "surya", "sun", "சூரியன்", "agni", "murugan", "கந்தன்", "முருகன்"]
  },
  {
    id: 8,
    slug: "rohini",
    nameEn: "Rohini",
    nameTa: "ரோகிணி",
    image: "/images/nakshatras/rohini.png",
    orderIndex: 8,
    assignedDate: "Oct 01, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Brahma & Lord Krishna",
    deityTa: "பிரம்மா & ஸ்ரீ கிருஷ்ணர்",
    rulingPlanet: "Moon (Chandra)",
    rulingPlanetTa: "சந்திரன்",
    symbol: "Cart / Chariot",
    symbolTa: "தேர் / வண்டி",
    rasi: "Vrishabha (Taurus)",
    rasiTa: "ரிஷபம்",
    sacredTree: "Naval (Syzygium cumini)",
    sacredElement: "Earth (Prithvi)",
    shortDescription: "The Star of Supreme Fertility, Abundance, Charm & Sri Krishna's Divine Avatar.",
    introContent: "Rohini is the favored star of the Moon and the Janma Nakshatra of Bhagavan Sri Krishna. This homam blesses devotees with fertile prosperity, artistic grace, and inner joy.",
    benefits: [
      "Expansion of business wealth, agriculture, and prosperity",
      "Mental peace, emotional stability and creative brilliance",
      "Marital joy and child blessings (Santhana Prapthi)",
      "Removal of Chandra Dosha and emotional unrest"
    ],
    moolaMantra: "Om Brahmane Namaha || Om Kleem Krishnaya Namaha",
    searchKeywords: ["rohini", "rogini", "rohinee", "roghini", "ரோகிணி", "ரோஹிணி", "vrishabha", "taurus", "ரிஷபம்", "chandra", "moon", "சந்திரன்", "brahma", "krishna", "கிருஷ்ணர்", "பிரம்மா"]
  },
  {
    id: 9,
    slug: "mrigashira",
    nameEn: "Mrigashira",
    nameTa: "மிருகசீரிஷம்",
    image: "/images/nakshatras/mrigashira.png",
    orderIndex: 9,
    assignedDate: "Oct 02, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Soma (Moon God / Divine Nectar)",
    deityTa: "சந்திர பகவான் / சோம தேவன்",
    rulingPlanet: "Mars (Sevvai / Mangal)",
    rulingPlanetTa: "செவ்வாய்",
    symbol: "Deer's Head (Seeking Truth)",
    symbolTa: "மான் தலை",
    rasi: "Vrishabha / Mithuna",
    rasiTa: "ரிஷபம் / மிதுனம்",
    sacredTree: "Karungali (Diospyros ebenum)",
    sacredElement: "Earth (Prithvi)",
    shortDescription: "The Star of Perpetual Searching, Divine Nectar & Soma's Blessed Serenity.",
    introContent: "Mrigashira embodies curiosity, intellectual clarity, and the soothing nectar of Soma. This homam harmonizes fiery Mars energy with cool lunar grace.",
    benefits: [
      "Clarity in career direction and intellectual pursuits",
      "Healing of nervous tension and relationship harmony",
      "Mars (Angaraka) dosha pacification",
      "Inspiration in travel, writing, and research"
    ],
    moolaMantra: "Om Somaya Namaha || Om Bhaumaya Namaha",
    searchKeywords: ["mrigashira", "mrigasira", "mrigasirsha", "mrigasiram", "mirugaseerisham", "mirugasirisham", "mirugaseeridam", "mirugasiram", "mirugashirsha", "மிருகசீரிஷம்", "மிருகசீர்ஷம்", "மிருகசீரிடம்", "மிருகசிரம்", "vrishabha", "mithuna", "gemini", "மிதுனம்", "sevvai", "mars", "mangal", "செவ்வாய்", "soma"]
  },
  {
    id: 10,
    slug: "ardra",
    nameEn: "Ardra",
    nameTa: "திருவாதிரை",
    image: "/images/nakshatras/ardra.png",
    orderIndex: 10,
    assignedDate: "Oct 03, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Rudra (Shiva / Cosmic Dissolution)",
    deityTa: "ஸ்ரீ ருத்ர பெருமான் (சிவபெருமான்)",
    rulingPlanet: "Rahu",
    rulingPlanetTa: "ராகு",
    symbol: "Teardrop / Diamond",
    symbolTa: "கண்ணீர்த்துளி / மாணிக்கம்",
    rasi: "Mithuna (Gemini)",
    rasiTa: "மிதுனம்",
    sacredTree: "Chengali (Acacia catechu)",
    sacredElement: "Water (Jala)",
    shortDescription: "The Star of Cosmic Dissolution, Rudra's Grace & Intense Spiritual Awakening.",
    introContent: "Ardra represents Lord Shiva's fierce compassion that destroys ignorance to make way for renewal. This homam purifies deep sorrow and neutralizes Rahu distress.",
    benefits: [
      "Dissolution of severe grief, sorrow and traumatic patterns",
      "Pacification of intense Rahu afflictions",
      "Awakening of profound spiritual realization",
      "Protection from hidden enemies and unforeseen calamities"
    ],
    moolaMantra: "Om Namo Bhagavate Rudraya || Om Raam Rahave Namaha",
    searchKeywords: ["ardra", "ardhra", "aarudhra", "arudhra", "arudra", "thiruvathirai", "thiruvadhirai", "thiruvaathirai", "aaruthira", "aaruthirai", "aruthra", "aruthirai", "aathirai", "athirai", "திருவாதிரை", "ஆருத்ரா", "ஆதிரை", "ருத்ரா", "mithuna", "gemini", "மிதுனம்", "rahu", "ராகு", "rudra", "shiva", "சிவபெருமான்"]
  },
  {
    id: 11,
    slug: "punarvasu",
    nameEn: "Punarvasu",
    nameTa: "புனர்பூசம்",
    image: "/images/nakshatras/punarvasu.png",
    orderIndex: 11,
    assignedDate: "Oct 04, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Goddess Aditi & Lord Sri Rama",
    deityTa: "அதிதி தேவி & ஸ்ரீ ராமச்சந்திர மூர்த்தி",
    rulingPlanet: "Jupiter (Guru)",
    rulingPlanetTa: "குரு (வியாழன்)",
    symbol: "Bow and Quiver of Arrows",
    symbolTa: "வில் மற்றும் அம்புக்கூடு",
    rasi: "Mithuna / Kataka",
    rasiTa: "மிதுனம் / கடகம்",
    sacredTree: "Moongil (Bamboo / Bambusa arundinacea)",
    sacredElement: "Water (Jala)",
    shortDescription: "The Star of the Divine Return, Renewal of Virtue & Lord Sri Rama's Supreme Avatar.",
    introContent: "Punarvasu signifies return of light and abundance. As the birth star of Maryada Purushottama Sri Rama, this homam brings victory over prolonged distress.",
    benefits: [
      "Recovery of lost wealth, property, and rightful status",
      "Overcoming family disputes and bringing unity",
      "Guru Preethi and divine protection across generations",
      "Re-establishment of virtue, peace, and inner contentment"
    ],
    moolaMantra: "Om Aditaye Namaha || Om Sri Ramachandraya Namaha",
    searchKeywords: ["punarvasu", "punarpoosam", "punarpusam", "punarpusham", "punarboosam", "punarvas", "புனர்பூசம்", "புனர்வசு", "mithuna", "kataka", "cancer", "கடகம்", "guru", "jupiter", "குரு", "வியாழன்", "aditi", "rama", "ராமர்"]
  },
  {
    id: 12,
    slug: "pushya",
    nameEn: "Pushya",
    nameTa: "பூசம்",
    image: "/images/nakshatras/pushya.png",
    orderIndex: 12,
    assignedDate: "Oct 05, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Brihaspati (Guru of the Gods)",
    deityTa: "பிருகஸ்பதி (தேவ குரு)",
    rulingPlanet: "Saturn (Shani)",
    rulingPlanetTa: "சனி",
    symbol: "Udder of Cow / Lotus / Circle",
    symbolTa: "பசுவின் மடி / தாமரை",
    rasi: "Kataka (Cancer)",
    rasiTa: "கடகம்",
    sacredTree: "Arasu (Ficus religiosa / Peepal)",
    sacredElement: "Water (Jala)",
    shortDescription: "The King of All 27 Nakshatras — The Star of Supreme Nourishment, Auspicious Dharma & Wisdom.",
    introContent: "Celebrated in scriptures as the most auspicious among stars, Pushya bestows immense dharma, spiritual nourishment, and turns difficult karma into blessings.",
    benefits: [
      "Success in all virtuous endeavors and financial security",
      "Shani Dosha relief and removal of chronic hardships",
      "Spiritual enlightenment and Guru's paduka grace",
      "Auspicious beginnings for education, home, and enterprise"
    ],
    moolaMantra: "Om Brihaspataye Namaha || Om Shanaishcharaya Namaha",
    searchKeywords: ["pushya", "poosam", "pusam", "pushyam", "pusyam", "poosam", "posam", "poosham", "boosam", "பூசம்", "புஷ்யம்", "kataka", "cancer", "கடகம்", "shani", "saturn", "சனி", "brihaspati", "guru", "தேவ குரு", "பிருகஸ்பதி"]
  },
  {
    id: 13,
    slug: "ashlesha",
    nameEn: "Ashlesha",
    nameTa: "ஆயில்யம்",
    image: "/images/nakshatras/ashlesha.png",
    orderIndex: 13,
    assignedDate: "Oct 06, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "The Naga Devas (Divine Serpents)",
    deityTa: "நாக தேவதைகள்",
    rulingPlanet: "Mercury (Budha)",
    rulingPlanetTa: "புதன்",
    symbol: "Coiled Serpent",
    symbolTa: "சுருண்ட பாம்பு",
    rasi: "Kataka (Cancer)",
    rasiTa: "கடகம்",
    sacredTree: "Punnai (Calophyllum inophyllum)",
    sacredElement: "Water (Jala)",
    shortDescription: "The Mystical Serpent Star of Intuition, Kundalini Awakening & Naga Dosha Nivarana.",
    introContent: "Ashlesha represents deep yogic wisdom and psychic shielding. This homam provides powerful remedy for Sarpa Doshas and elevates intuitive mastery.",
    benefits: [
      "Complete pacification of Sarpa Dosha and Naga curses",
      "Protection against venomous harms and hidden adversaries",
      "Awakening of sharp intellect, diplomacy, and insight",
      "Clearing psychic and ancestral blockages in the family"
    ],
    moolaMantra: "Om Sarpebhyo Namaha || Om Budhaya Namaha",
    searchKeywords: ["ashlesha", "ayilyam", "aayilyam", "aslesha", "aayiliyam", "ayiliyam", "azhlesha", "ஆயில்யம்", "ஆயில்ய", "ஆயில்லியம்", "அஸ்லேஷா", "kataka", "cancer", "கடகம்", "budha", "mercury", "புதன்", "naga", "sarpa", "நாகர்", "நாக தேவதை"]
  },
  {
    id: 14,
    slug: "magha",
    nameEn: "Magha",
    nameTa: "மகம்",
    image: "/images/nakshatras/magha.png",
    orderIndex: 14,
    assignedDate: "Oct 07, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "The Pitrus (Ancestral Spirits)",
    deityTa: "பித்ருக்கள் (முன்னோர்கள்)",
    rulingPlanet: "Ketu",
    rulingPlanetTa: "கேது",
    symbol: "Royal Throne / Palanquin",
    symbolTa: "அரியணை / பல்லக்கு",
    rasi: "Simha (Leo)",
    rasiTa: "சிம்மம்",
    sacredTree: "Aal (Banyan / Ficus benghalensis)",
    sacredElement: "Water (Jala)",
    shortDescription: "The Royal Star of Ancestral Honor, Lineage Sovereignty & Pitru Blessing.",
    introContent: "Magha links human life to the ancestral realm (Pitru Loka). This sacred homam pleases forefathers, clearing generational blockages to grant royal dignity.",
    benefits: [
      "Cleansing of severe Pitru Dosha and ancestral curses",
      "Elevation in leadership, fame, and royal dignity",
      "Prosperity across generations and children's welfare",
      "Deep spiritual grounding and connection to noble roots"
    ],
    moolaMantra: "Om Pitrubhyo Namaha || Om Ketave Namaha",
    searchKeywords: ["magha", "magam", "makam", "maham", "maka", "maga", "மகம்", "மக", "simha", "leo", "சிம்மம்", "ketu", "கேது", "pitrus", "பித்ருக்கள்", "முன்னோர்கள்"]
  },
  {
    id: 15,
    slug: "purva-phalguni",
    nameEn: "Purva Phalguni",
    nameTa: "பூரம்",
    image: "/images/nakshatras/purva_phalguni.png",
    orderIndex: 15,
    assignedDate: "Oct 08, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Bhaga Deva & Goddess Sri Andal",
    deityTa: "பக தேவன் & ஸ்ரீ ஆண்டாள் நாச்சியார்",
    rulingPlanet: "Venus (Shukra)",
    rulingPlanetTa: "சுக்கிரன்",
    symbol: "Front Legs of Bed / Swing",
    symbolTa: "ஊஞ்சல் / கட்டிலின் முன் கால்கள்",
    rasi: "Simha (Leo)",
    rasiTa: "சிம்மம்",
    sacredTree: "Palasu (Butea monosperma)",
    sacredElement: "Water (Jala)",
    shortDescription: "The Star of Divine Romance, Creative Bliss, Conjugal Joy & Goddess Andal's Manifestation.",
    introContent: "Purva Phalguni brings the joy of divine love and prosperity. As the manifestation star of Sri Andal, this homam is peerless for matrimonial bliss.",
    benefits: [
      "Timely and harmonious marriage alliances (Kalyana Prapthi)",
      "Relief from financial hardship through Lakshmi-Shukra blessing",
      "Artistic inspiration and inner joy",
      "Strengthening of family bonds and social reputation"
    ],
    moolaMantra: "Om Bhagaya Namaha || Om Sri Andal Thiruvaadikaley Sharanam",
    searchKeywords: ["purva phalguni", "pooram", "puram", "poora", "purva palguni", "purvaphalguni", "poorathil", "pubba", "பூரம்", "பூர", "பூர்வ பல்குனி", "simha", "leo", "சிம்மம்", "shukra", "venus", "சுக்கிரன்", "bhaga", "andal", "ஆண்டாள்"]
  },
  {
    id: 16,
    slug: "uttara-phalguni",
    nameEn: "Uttara Phalguni",
    nameTa: "உத்திரம்",
    image: "/images/nakshatras/uttara_phalguni.png",
    orderIndex: 16,
    assignedDate: "Oct 09, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Aryaman (God of Patronage & Noble Pacts)",
    deityTa: "அர்யமா தேவன்",
    rulingPlanet: "Sun (Surya)",
    rulingPlanetTa: "சூரியன்",
    symbol: "Back Legs of Bed / Four Legs",
    symbolTa: "கட்டிலின் பின் கால்கள்",
    rasi: "Simha / Kanya",
    rasiTa: "சிம்மம் / கன்னி",
    sacredTree: "Arali (Nerium oleander)",
    sacredElement: "Fire (Agni)",
    shortDescription: "The Star of Noble Generosity, Enduring Alliances & Celestial Harmony.",
    introContent: "Uttara Phalguni governs enduring friendships, contracts, and royal benevolence. This homam aligns devotees with high state patronage and solar radiance.",
    benefits: [
      "Stability in long-term partnerships and royal contracts",
      "Government approvals and professional promotions",
      "Surya Preethi for health, vitality, and eyesight",
      "Harmony in marital life and social benevolence"
    ],
    moolaMantra: "Om Aryamne Namaha || Om Suryaya Namaha",
    searchKeywords: ["uttara phalguni", "uthiram", "uththiram", "uttiram", "uthira", "uttara palguni", "uttaraphalguni", "உத்திரம்", "உத்திர", "உத்தர பல்குனி", "simha", "kanya", "virgo", "கன்னி", "surya", "sun", "சூரியன்", "aryaman", "அர்யமா"]
  },
  {
    id: 17,
    slug: "hasta",
    nameEn: "Hasta",
    nameTa: "ஹஸ்தம்",
    image: "/images/nakshatras/hasta.png",
    orderIndex: 17,
    assignedDate: "Oct 10, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Savitur (The Solar Creator)",
    deityTa: "சவிதா (சூரிய நாராயணர்)",
    rulingPlanet: "Moon (Chandra)",
    rulingPlanetTa: "சந்திரன்",
    symbol: "Hand / Open Palm with Blessings",
    symbolTa: "கை / ஆசிர்வதிக்கும் உள்ளங்கை",
    rasi: "Kanya (Virgo)",
    rasiTa: "கன்னி",
    sacredTree: "Aththi (Ficus carica)",
    sacredElement: "Fire (Agni)",
    shortDescription: "The Golden Hand of Divine Manifestation, Craftsmanship, Healing Touch & Solar Intelligence.",
    introContent: "Hasta holds the power of purposeful action, healing hands, and manifestation. This homam blesses craftsmen, doctors, and entrepreneurs with divine dexterity.",
    benefits: [
      "Skill mastery in profession, trade, and enterprise",
      "Relief from anxiety, doubt, and emotional flux",
      "Gayatri Savitur energy alignment for sharp intelligence",
      "Prosperity in business partnerships and commerce"
    ],
    moolaMantra: "Om Savitre Namaha || Om Chandraya Namaha",
    searchKeywords: ["hasta", "hastham", "astham", "hastha", "astha", "hasthathil", "ஹஸ்தம்", "அஸ்தம்", "ஹஸ்த", "kanya", "virgo", "கன்னி", "chandra", "moon", "சந்திரன்", "savitur", "savitha", "சவிதா"]
  },
  {
    id: 18,
    slug: "chitra",
    nameEn: "Chitra",
    nameTa: "சித்திரை",
    image: "/images/nakshatras/chitra.png",
    orderIndex: 18,
    assignedDate: "Oct 11, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Twashtar / Vishwakarma (Divine Architect)",
    deityTa: "விஸ்வகர்மா / துவஷ்டா",
    rulingPlanet: "Mars (Sevvai)",
    rulingPlanetTa: "செவ்வாய்",
    symbol: "Bright Jewel / Pearl",
    symbolTa: "பளபளக்கும் ரத்தினம் / முத்து",
    rasi: "Kanya / Tula",
    rasiTa: "கன்னி / துலாம்",
    sacredTree: "Vilvam (Aegle marmelos / Bael)",
    sacredElement: "Fire (Agni)",
    shortDescription: "The Brilliant Jewel Star of Aesthetics, Architectural Creation & Cosmic Design.",
    introContent: "Chitra is the gem of the heavens, sparking creativity, architectural wonder, and personal charisma. This homam blesses creators, engineers, and property builders.",
    benefits: [
      "Blessings for real estate construction and property gain",
      "Magnetism, charisma and artistic breakthrough",
      "Mars energy transmutation into constructive excellence",
      "Fame in design, engineering, and visual arts"
    ],
    moolaMantra: "Om Tvashtre Namaha || Om Bhaumaya Namaha",
    searchKeywords: ["chitra", "chithirai", "chithira", "chitirai", "chithra", "sithirai", "chitha", "சித்திரை", "சித்திரா", "சித்ரா", "kanya", "tula", "libra", "துலாம்", "sevvai", "mars", "செவ்வாய்", "vishwakarma", "விஸ்வகர்மா"]
  },
  {
    id: 19,
    slug: "swati",
    nameEn: "Swati",
    nameTa: "சுவாதி",
    image: "/images/nakshatras/swati.png",
    orderIndex: 19,
    assignedDate: "Oct 12, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Vayu (Wind God) & Lord Narasimha",
    deityTa: "வாயு பகவான் & ஸ்ரீ நரசிம்மர்",
    rulingPlanet: "Rahu",
    rulingPlanetTa: "ராகு",
    symbol: "Young Shoot / Coral Shoot",
    symbolTa: "பவளக்கொடி / இளம்பயிர்",
    rasi: "Tula (Libra)",
    rasiTa: "துலாம்",
    sacredTree: "Marudham (Terminalia arjuna)",
    sacredElement: "Fire (Agni)",
    shortDescription: "The Independent Coral Shoot of Divine Freedom, Prana Shakti & Lord Narasimha's Protection.",
    introContent: "Swati represents divine breath (Prana), independence, and Lord Narasimha's supreme shield. This homam cuts negative influences and brings commercial success.",
    benefits: [
      "Supreme protection against black magic and unseen foes",
      "Commercial trading success and adaptability in career",
      "Prana rejuvenation and respiratory health blessings",
      "Overcoming Rahu transit challenges with Narasimha's grace"
    ],
    moolaMantra: "Om Vaayave Namaha || Om Narasimhaya Namaha",
    searchKeywords: ["swati", "swathi", "suvathi", "swathy", "svati", "chothi", "சுவாதி", "tula", "libra", "துலாம்", "rahu", "ராகு", "vayu", "வாயு பகவான்", "narasimha", "நரசிம்மர்"]
  },
  {
    id: 20,
    slug: "vishakha",
    nameEn: "Vishakha",
    nameTa: "விசாகம்",
    image: "/images/nakshatras/vishakha.png",
    orderIndex: 20,
    assignedDate: "Oct 13, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Indra & Agni (Dual Cosmic Forces)",
    deityTa: "இந்திரன் & அக்னி தேவன்",
    rulingPlanet: "Jupiter (Guru)",
    rulingPlanetTa: "குரு (வியாழன்)",
    symbol: "Triumphal Arch / Potter's Wheel",
    symbolTa: "தோரணம் / குயவர் சக்கரம்",
    rasi: "Tula / Vrischika",
    rasiTa: "துலாம் / விருச்சிகம்",
    sacredTree: "Vilamaram (Limonia acidissima)",
    sacredElement: "Fire (Agni)",
    shortDescription: "The Star of Triumphant Purpose, Single-Minded Focus & Lord Muruga's Advent.",
    introContent: "Vishakha channels the dual power of Indra (authority) and Agni (energy). As Lord Muruga's birth star (Vaikasi Visakam), this homam secures victory.",
    benefits: [
      "Victory over court disputes and fierce competitors",
      "Success in academic and high civil examinations",
      "Guru and Agni preethi for ambition fulfillment",
      "Transforming spiritual discipline into tangible success"
    ],
    moolaMantra: "Om Indragnibhyam Namaha || Om Gurave Namaha",
    searchKeywords: ["vishakha", "visakam", "visagam", "visaka", "vishakam", "vishak", "விசாகம்", "விசாக", "விசாகா", "tula", "vrischika", "scorpio", "விருச்சிகம்", "guru", "jupiter", "குரு", "indra", "agni", "இந்திரன்", "அக்னி"]
  },
  {
    id: 21,
    slug: "anuradha",
    nameEn: "Anuradha",
    nameTa: "அனுஷம்",
    image: "/images/nakshatras/anuradha.png",
    orderIndex: 21,
    assignedDate: "Oct 14, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Mitra Deva (God of Friendship & Light)",
    deityTa: "மித்ர தேவன் & மகா பெரியவா",
    rulingPlanet: "Saturn (Shani)",
    rulingPlanetTa: "சனி",
    symbol: "Lotus Flower / Staff",
    symbolTa: "தாமரை / தண்டம்",
    rasi: "Vrischika (Scorpio)",
    rasiTa: "விருச்சிகம்",
    sacredTree: "Magizham (Mimusops elengi)",
    sacredElement: "Fire (Agni)",
    shortDescription: "The Star of Divine Friendship, Bhakti, Kanchi Mahaperiyava & Mitra's Light.",
    introContent: "Anuradha blossoms like a lotus in still waters, representing devotion and harmony. Blessed by Kanchi Mahaperiyava, this homam eases Shani hardships.",
    benefits: [
      "Deep inner peace and sincere devotee fellowship",
      "Protection during Sade Sati (7.5 years Shani) and Ashtama Shani",
      "Universal goodwill, diplomacy, and overseas success",
      "Awakening of pure Bhakti and Guru Paduka blessings"
    ],
    moolaMantra: "Om Mitraya Namaha || Om Shanaishcharaya Namaha",
    searchKeywords: ["anuradha", "anusham", "anusam", "anoosham", "anusha", "anizham", "அனுஷம்", "அனுசம்", "அனுராதா", "vrischika", "scorpio", "விருச்சிகம்", "shani", "saturn", "சனி", "mitra", "மித்ரா"]
  },
  {
    id: 22,
    slug: "jyeshtha",
    nameEn: "Jyeshtha",
    nameTa: "கேட்டை",
    image: "/images/nakshatras/jyeshtha.png",
    orderIndex: 22,
    assignedDate: "Oct 15, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Indra (King of Devas)",
    deityTa: "இந்திர பகவான் (தேவேந்திரன்)",
    rulingPlanet: "Mercury (Budha)",
    rulingPlanetTa: "புதன்",
    symbol: "Circular Earring / Protective Talisman",
    symbolTa: "வட்ட வடிவ காதணி / கவசம்",
    rasi: "Vrischika (Scorpio)",
    rasiTa: "விருச்சிகம்",
    sacredTree: "Pirai (Streblus asper)",
    sacredElement: "Air (Vayu)",
    shortDescription: "The Eldest Star of Supreme Authority, Indra's Thunderbolt & Protective Talisman.",
    introContent: "Jyeshtha signifies leadership, courage, and elder wisdom. Governed by Indra, this homam protects administrative status and shields ancestral wealth.",
    benefits: [
      "Leadership authority and triumph over hidden traps",
      "Protection of family elders and ancestral wealth",
      "Mercury (Budha) pacification for keen business strategy",
      "Elevation to chief responsibilities in organizations"
    ],
    moolaMantra: "Om Indraya Namaha || Om Saumyaaya Namaha",
    searchKeywords: ["jyeshtha", "jyeshta", "kettai", "ketai", "kaettai", "kettay", "jesta", "keta", "கேட்டை", "ஜ்யேஷ்டா", "vrischika", "scorpio", "விருச்சிகம்", "budha", "mercury", "புதன்", "indra", "இந்திரன்"]
  },
  {
    id: 23,
    slug: "mula",
    nameEn: "Mula",
    nameTa: "மூலம்",
    image: "/images/nakshatras/mula.png",
    orderIndex: 23,
    assignedDate: "Oct 16, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Goddess Nirriti & Lord Hanuman",
    deityTa: "நிருதி தேவி & ஸ்ரீ ஆஞ்சநேயர்",
    rulingPlanet: "Ketu",
    rulingPlanetTa: "கேது",
    symbol: "Tied Bundle of Roots / Elephant Goad",
    symbolTa: "வேர்க்கட்டு / அங்குசம்",
    rasi: "Dhanus (Sagittarius)",
    rasiTa: "தனுசு",
    sacredTree: "Maramalli (Millingtonia hortensis)",
    sacredElement: "Air (Vayu)",
    shortDescription: "The Root Star of Galactic Core, Deep Uprooting & Goddess Nirriti's Awakening.",
    introContent: "Mula taps directly into the galactic center, uprooting deep karmic diseases and financial distress. Blessed by Lord Hanuman, this homam is profoundly protective.",
    benefits: [
      "Uprooting the primary source of financial and health distress",
      "Supreme blessings of Lord Hanuman for strength and courage",
      "Spiritual liberation and dissolution of root karma",
      "Ketu Dosha Nivarana and profound inner clarity"
    ],
    moolaMantra: "Om Nirritaye Namaha || Om Hum Hanumate Namaha",
    searchKeywords: ["moola", "moolam", "mula", "mulam", "moolaa", "mulaa", "மூலம்", "மூல", "dhanus", "sagittarius", "தனுசு", "ketu", "கேது", "nirriti", "நிருதி", "anjaneyar", "ஆஞ்சநேயர்"]
  },
  {
    id: 24,
    slug: "purva-ashadha",
    nameEn: "Purva Ashadha",
    nameTa: "பூராடம்",
    image: "/images/nakshatras/purva_ashadha.png",
    orderIndex: 24,
    assignedDate: "Oct 17, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Apas (Cosmic Water Goddesses)",
    deityTa: "அபஸ் (ஜல தேவதைகள்) & வரலட்சுமி",
    rulingPlanet: "Venus (Shukra)",
    rulingPlanetTa: "சுக்கிரன்",
    symbol: "Winnowing Basket / Fan",
    symbolTa: "முறம் / விசிறி",
    rasi: "Dhanus (Sagittarius)",
    rasiTa: "தனுசு",
    sacredTree: "Vanchi (Salix tetrasperma)",
    sacredElement: "Air (Vayu)",
    shortDescription: "The Invincible Star of Cosmic Waters, Goddess Apas & Unconquerable Victory.",
    introContent: "Purva Ashadha is the invincible star that purifies like celestial water and brings unyielding victory. Governed by Shukra, it brings joy and liquid wealth.",
    benefits: [
      "Unconquerable victory in legal and commercial struggles",
      "Purification of mind and emotional cleansing",
      "Shukra blessings for luxury, vehicles, and joy",
      "Removal of deep guilt and emotional stagnation"
    ],
    moolaMantra: "Om Adbhyo Namaha || Om Shukraya Namaha",
    searchKeywords: ["purva ashadha", "pooradam", "puradam", "pooraadam", "pooradam", "purvashada", "purva asada", "பூராடம்", "பூராட", "பூர்வாஷாடம்", "dhanus", "sagittarius", "தனுசு", "shukra", "venus", "சுக்கிரன்", "apah", "வருணன்"]
  },
  {
    id: 25,
    slug: "uttara-ashadha",
    nameEn: "Uttara Ashadha",
    nameTa: "உத்திராடம்",
    image: "/images/nakshatras/uttara_ashadha.png",
    orderIndex: 25,
    assignedDate: "Oct 18, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Ten Vishvadevas (Universal Cosmic Deities)",
    deityTa: "விஸ்வதேவர்கள் (பத்து பிரபஞ்ச தேவர்கள்)",
    rulingPlanet: "Sun (Surya)",
    rulingPlanetTa: "சூரியன்",
    symbol: "Elephant Tusk / Small Cot",
    symbolTa: "யானைத் தந்தம் / சிறு கட்டில்",
    rasi: "Dhanus / Makara",
    rasiTa: "தனுசு / மகரம்",
    sacredTree: "Pala (Jackfruit / Artocarpus heterophyllus)",
    sacredElement: "Air (Vayu)",
    shortDescription: "The Star of Universal Virtues, Ten Vishvadevas & Eternal Triumph.",
    introContent: "Uttara Ashadha represents permanent victory based on righteousness. Blessed by the Ten Vishvadevas and Lord Ganesha, it establishes unshakeable stability.",
    benefits: [
      "Unshakeable permanent success in righteous work",
      "High societal respect and leadership recognition",
      "Surya blessing for health, vitality, and noble allies",
      "Removal of impediments in career expansion"
    ],
    moolaMantra: "Om Vishvebhyo Devebhyo Namaha || Om Suryaya Namaha",
    searchKeywords: ["uttara ashadha", "uthiradam", "uttiradam", "uthiraadam", "uttarashada", "uttara asada", "உத்திராடம்", "உத்திராட", "உத்தராஷாடம்", "dhanus", "makara", "capricorn", "மகரம்", "surya", "sun", "சூரியன்", "vishwadevas", "விஸ்வேதேவர்கள்"]
  },
  {
    id: 26,
    slug: "shravana",
    nameEn: "Shravana",
    nameTa: "திருவோணம்",
    image: "/images/nakshatras/shravana.png",
    orderIndex: 26,
    assignedDate: "Oct 19, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Lord Maha Vishnu & Goddess Saraswati",
    deityTa: "ஸ்ரீ மகாவிஷ்ணு & சரஸ்வதி தேவி",
    rulingPlanet: "Moon (Chandra)",
    rulingPlanetTa: "சந்திரன்",
    symbol: "Three Footprints / Ear",
    symbolTa: "மூன்று பாதங்கள் / காது",
    rasi: "Makara (Capricorn)",
    rasiTa: "மகரம்",
    sacredTree: "Erukku (Calotropis gigantea)",
    sacredElement: "Air (Vayu)",
    shortDescription: "The Star of Divine Listening, Supreme Learning & Lord Maha Vishnu's Advent.",
    introContent: "Shravana is the sacred star of Lord Venkateshwara and Maha Vishnu. This homam blesses devotees with divine knowledge, academic excellence, and wealth.",
    benefits: [
      "Blessings of Lord Venkateshwara and Maha Vishnu",
      "Academic brilliance, wisdom and receptive learning",
      "Chandra preethi for peace of mind and mental balance",
      "Safe acquisition of assets and financial security"
    ],
    moolaMantra: "Om Vishnave Namaha || Om Chandraya Namaha",
    searchKeywords: ["shravana", "thiruvonam", "thiruvoanam", "thiruonam", "sravana", "shravan", "sravanam", "திருவோணம்", "திருவோண", "ஷ்ரவணம்", "சிரவணம்", "makara", "capricorn", "மகரம்", "chandra", "moon", "சந்திரன்", "vishnu", "venkatachalapathy", "மகாவிஷ்ணு", "பெருமாள்"]
  },
  {
    id: 27,
    slug: "dhanishta",
    nameEn: "Dhanishta",
    nameTa: "அவிட்டம்",
    image: "/images/nakshatras/dhanishta.png",
    orderIndex: 27,
    assignedDate: "Oct 20, 2026",
    eventTime: "6:00 AM - 1:00 PM",
    deity: "Ashta Vasus (Eight Gods of Abundance)",
    deityTa: "அஷ்ட வசுக்கள் (செல்வத் தேவர்கள்)",
    rulingPlanet: "Mars (Sevvai / Mangal)",
    rulingPlanetTa: "செவ்வாய்",
    symbol: "Mridangam / Drum / Flute",
    symbolTa: "மிருதங்கம் / புல்லாங்குழல்",
    rasi: "Makara / Kumbha",
    rasiTa: "மகரம் / கும்பம்",
    sacredTree: "Vanni (Prosopis cineraria)",
    sacredElement: "Ether (Akasha)",
    shortDescription: "The Star of Inexhaustible Wealth, Cosmic Rhythm & The Eight Vasus.",
    introContent: "Dhanishta is the glorious 27th crowning star marking the Grand Purnahuti culmination of our 27-Day Maha Yagna. Governed by the Ashta Vasus, this homam opens locked doors of fortune and supreme material abundance.",
    benefits: [
      "Wealth expansion and financial stability",
      "Fame in performing arts, music, and public communication",
      "Sevvai (Mars) dosha relief for marriage stability",
      "Real estate acquisition and prosperity through assets",
      "Attainment of full merits of the Grand Purnahuti Yagna"
    ],
    moolaMantra: "Om Vasubhyo Namaha || Om Bhaumaya Namaha",
    searchKeywords: ["dhanishta", "avittam", "avitham", "dhanishta", "danishta", "avittathil", "அவிட்டம்", "அவிட்ட", "தனிஷ்டா", "makara", "kumbha", "aquarius", "கும்பம்", "sevvai", "mars", "செவ்வாய்", "ashta vasus", "அஷ்ட வசுக்கள்"]
  }
];

// Automatically decorate all 27 stars with calculated dates & real-time registration statuses
export const MOCK_NAKSHATRAS = RAW_NAKSHATRAS.map((nak) => ({
  ...nak,
  assignedDate: formatHomamDate(nak.orderIndex),
  formattedDateShort: formatHomamDate(nak.orderIndex, { short: true }),
  registrationStatus: getRegistrationStatus(nak.orderIndex),
}));

/* =========================================================
   📅 REAL-TIME ACTIVE HOMAM DAY CALCULATION
   Dynamically determines today's active star based on the calendar date.
   If before Sep 24, 2026, falls back to Day 1 (Opening Day) with full indication.
   ========================================================= */
export const getActiveHomamDayInfo = () => {
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const eventStart = new Date(HOMAM_START_YEAR, HOMAM_START_MONTH, HOMAM_START_DAY);

  const msPerDay = 1000 * 60 * 60 * 24;
  const daysDiff = Math.round((todayStart - eventStart) / msPerDay);

  // Before event start date (e.g. today is before September 24, 2026)
  if (daysDiff < 0) {
    const daysUntilStart = Math.abs(daysDiff);
    const firstStar = MOCK_NAKSHATRAS[0];
    const secondStar = MOCK_NAKSHATRAS[1];

    return {
      isEventActive: false,
      isUpcoming: true,
      isCompleted: false,
      dayNumber: 1,
      dateLabel: `Day 1 (Opening Day - ${firstStar.assignedDate})`,
      activeStar: firstStar,
      tomorrowStar: secondStar,
      statusBadge: "Upcoming Maha Yagna",
      statusNotice: `Sri 27 Nakshatra Maha Homam commences on September 24, 2026. Showing Day 1: ${firstStar.nameEn} (${firstStar.nameTa}) Opening Day Schedule. Devotees can register now for their dedicated birth star days.`,
      daysRemaining: daysUntilStart,
      eventStartDate: "September 24, 2026",
      isFirstDayIndication: true,
    };
  }

  // During 27-day event (Sep 24, 2026 – Oct 20, 2026)
  if (daysDiff >= 0 && daysDiff < 27) {
    const dayNumber = daysDiff + 1;
    const activeStar = MOCK_NAKSHATRAS.find((n) => n.orderIndex === dayNumber) || MOCK_NAKSHATRAS[0];
    const nextIndex = dayNumber < 27 ? dayNumber + 1 : 1;
    const tomorrowStar = MOCK_NAKSHATRAS.find((n) => n.orderIndex === nextIndex) || MOCK_NAKSHATRAS[1];

    return {
      isEventActive: true,
      isUpcoming: false,
      isCompleted: false,
      dayNumber,
      dateLabel: `Day ${dayNumber} of 27 (${activeStar.assignedDate})`,
      activeStar,
      tomorrowStar,
      statusBadge: `Today's Active Star (Day ${dayNumber} of 27)`,
      statusNotice: `Today at Sri Gnana Sai Baba Mandir, we invoke the divine grace for ${activeStar.nameEn} (${activeStar.nameTa}) Nakshatra with 10,008 sacred Ahutis in the consecrated Agni Kunda.`,
      daysRemaining: 27 - dayNumber,
      eventStartDate: "September 24, 2026",
      isFirstDayIndication: false,
    };
  }

  // After event has concluded
  const lastStar = MOCK_NAKSHATRAS[MOCK_NAKSHATRAS.length - 1];
  return {
    isEventActive: false,
    isUpcoming: false,
    isCompleted: true,
    dayNumber: 27,
    dateLabel: `Grand Culmination (${lastStar.assignedDate})`,
    activeStar: lastStar,
    tomorrowStar: MOCK_NAKSHATRAS[0],
    statusBadge: "27-Day Maha Yagna Concluded",
    statusNotice: "The 27 Nakshatra Maha Homam successfully concluded on October 20, 2026. Explore all 27 sacred Nakshatras and individual pooja benefits below.",
    daysRemaining: 0,
    eventStartDate: "September 24, 2026",
    isFirstDayIndication: false,
  };
};

export const MOCK_DAILY_UPDATE = {
  date: "Day 1 of 27 Days Maha Yagna",
  nakshatraId: 1,
  message: "Today at Sri Gnana Sai Baba Mandir, we invoke the divine healing grace of Lord Varuna and Rahu with 10,008 sacred Ahutis in the consecrated Agni Kunda on the auspicious opening day of Shatabhisha (Sathayam) Nakshatra. Devotees receive miraculous cure from chronic illnesses, vital energy, and wellness.",
  specialMantra: "Om Varunaya Namaha || Om Rahave Namaha",
  specialMantraMeaning: "Salutations to Lord Varuna and Lord Rahu for supreme healing, cosmic protection, and auspicious beginnings.",
  dailySchedule: [
    { time: "05:50 AM", ritual: "Temple Open", description: "Morning sanctum doors open for devotees and morning prayers" },
    { time: "06:15 AM", ritual: "Kakad Aarti", description: "Morning awakening Aarti & Mangala Harathi to Sri Sai Baba" },
    { time: "07:00 AM", ritual: "Gho Pooja", description: "Auspicious Cow Pooja & Kamadhenu worship for peace and prosperity" },
    { time: "07:30 AM", ritual: "Sri Baba Abhishekam", description: "Sacred Panchamrutha & Holy Theertha bath ritual" },
    { time: "09:30 AM – 11:00 AM", ritual: "Sri Sai Sahasranama Homam", description: "Sacred 1,008 divine names chanting & special Nakshatra Ahuti in Agni Kunda (Devotees attending in person are requested to arrive by 09:00 AM)" },
    { time: "12:00 PM", ritual: "Afternoon Aarti", description: "Midday Madhyan Aarti and deeparadhana offering" },
    { time: "12:30 PM", ritual: "Maha Annadhanam", description: "Distribution of consecrated Prasadam & holy meals to all devotees" },
    { time: "02:00 PM", ritual: "Temple Closed", description: "Afternoon sanctum rest period" },
    { time: "04:30 PM", ritual: "Temple Re-opens", description: "Evening sanctum doors open for darshan and prayers" },
    { time: "06:00 PM", ritual: "Dhoop Aarti", description: "Evening Sandhya Aarti, incense offering & bhajans" },
    { time: "08:30 PM", ritual: "Shej Aarti", description: "Night divine lullaby Aarti and final day blessings" },
    { time: "09:00 PM", ritual: "Temple Closed", description: "Sanctum doors close peacefully for the night" }
  ]
};

export const MOCK_UPCOMING_UPDATE = {
  date: "Day 2 of 27 Days Maha Yagna",
  nakshatraId: 2,
  message: "Tomorrow's sacred fire will honor Poorattathi (Purva Bhadrapada) Nakshatra ruled by Aja Ekapada & Jupiter (Guru), channeling ascetic fire, transformational power, and divine evolution."
};

export const MOCK_GALLERY_ASSETS = LOCAL_GALLERY_PHOTOS;

export function getDynamicWhatsAppNumber() {
  if (typeof window !== "undefined") {
    const cached = window.__MANDIR_WHATSAPP_NUMBER__ || localStorage.getItem("mandir_whatsapp_number");
    if (cached && cached.trim() && !cached.includes("9080845897")) return cached.trim();
  }
  return MOCK_SITE_SETTINGS.whatsappNumber || "916369482332";
}

export function getDynamicFormattedWhatsApp() {
  if (typeof window !== "undefined") {
    const cached = window.__MANDIR_WHATSAPP_FORMATTED__ || localStorage.getItem("mandir_whatsapp_formatted");
    if (cached && cached.trim() && !cached.includes("90808")) return cached.trim();
  }
  const digits = getDynamicWhatsAppNumber();
  if (digits.length === 10) return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
  if (digits.startsWith("91") && digits.length === 12) return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`;
  return `+${digits}`;
}

export function getWhatsAppLink({ customMessage, nakshatraName, nakshatraDay, source, phone, customNumber } = {}) {
  // Always use dynamic number unless an explicit different external recipient phone number is provided
  let number = customNumber;
  if (!number && phone && phone !== "916369482332" && phone !== "919751188789" && phone !== "919080845897" && phone !== MOCK_SITE_SETTINGS.whatsappNumber) {
    number = phone;
  }
  if (!number) {
    number = getDynamicWhatsAppNumber();
  }
  number = String(number || "").replace(/\D/g, "") || "916369482332";
  if (number.includes("9080845897")) {
    number = "916369482332";
  }

  let text = customMessage;
  if (!text) {
    if (nakshatraName && nakshatraDay) {
      text = `Namaste Sri Gnana Sai Baba Mandir Team 🙏\nI would like to participate in Day ${nakshatraDay} (${nakshatraName} Nakshatra) Maha Homam.`;
    } else {
      text = `Namaste Sri Gnana Sai Baba Mandir Team 🙏\nI would like to know more about the ${MOCK_SITE_SETTINGS.eventName}.`;
    }
  }
  return `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(text)}`;
}

export function searchNakshatras(query, nakshatras = MOCK_NAKSHATRAS) {
  if (!query || !query.trim()) return nakshatras;
  const raw = query.trim().toLowerCase();
  const cleanQ = raw.replace(/[\s\-_.]/g, '');

  return nakshatras.filter((n) => {
    // 1. Direct name matches (English & Tamil)
    if (n.nameEn.toLowerCase().includes(raw)) return true;
    if (n.nameTa.includes(query.trim())) return true;
    if (n.slug.replace(/-/g, '').includes(cleanQ)) return true;
    if (n.rasi.toLowerCase().includes(raw) || n.rasiTa.includes(query.trim())) return true;
    if (n.deity.toLowerCase().includes(raw) || n.deityTa.includes(query.trim())) return true;
    if (n.rulingPlanet.toLowerCase().includes(raw) || n.rulingPlanetTa.includes(query.trim())) return true;

    // 2. Search in comprehensive Tanglish and Tamil searchKeywords
    if (n.searchKeywords && Array.isArray(n.searchKeywords)) {
      return n.searchKeywords.some((kw) => {
        const cleanKw = kw.toLowerCase().replace(/[\s\-_.]/g, '');
        return cleanKw.includes(cleanQ) || kw.toLowerCase().includes(raw) || (query.trim() && kw.includes(query.trim()));
      });
    }

    return false;
  });
}

export function findMatchingNakshatra(query, nakshatras = MOCK_NAKSHATRAS) {
  if (!query || !query.trim()) return null;
  const raw = query.trim().toLowerCase();
  const cleanQ = raw.replace(/[\s\-_.]/g, '');

  // 1. Exact/Prefix matches on English name or Tamil name or Slug
  let match = nakshatras.find(
    (n) =>
      n.nameEn.toLowerCase().startsWith(raw) ||
      n.slug.startsWith(cleanQ) ||
      n.nameTa.startsWith(query.trim())
  );
  if (match) return match;

  // 2. Keyword exact / prefix match (Tanglish / Tamil)
  match = nakshatras.find((n) =>
    n.searchKeywords && n.searchKeywords.some((kw) => {
      const cleanKw = kw.toLowerCase().replace(/[\s\-_.]/g, '');
      return cleanKw.startsWith(cleanQ) || kw.startsWith(query.trim());
    })
  );
  if (match) return match;

  // 3. Substring match in searchKeywords or details
  match = nakshatras.find((n) => {
    if (n.nameEn.toLowerCase().includes(raw) || n.nameTa.includes(query.trim())) return true;
    if (n.rasi.toLowerCase().includes(raw) || n.deity.toLowerCase().includes(raw) || n.rulingPlanet.toLowerCase().includes(raw)) return true;
    return n.searchKeywords && n.searchKeywords.some((kw) => kw.toLowerCase().includes(raw) || kw.includes(query.trim()));
  });

  return match || null;
}
